import { render, staticRenderFns } from "./ConfigurationCompanyProfileForm.vue?vue&type=template&id=3dbf4545&scoped=true&"
import script from "./ConfigurationCompanyProfileForm.vue?vue&type=script&lang=js&"
export * from "./ConfigurationCompanyProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbf4545",
  null
  
)

export default component.exports